import React, { useEffect, useState, ChangeEvent } from 'react';
import Modal from 'components/Modal/Modal';
import Button from 'components/Button';
import Input from 'components/Input';
import { ReactComponent as PasswordIcon } from 'assets/heroicons/icon-key.svg';
import { toast } from 'react-toastify';
import Auth from '@aws-amplify/auth';

const ChangePasswordButton = () => {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');

  const changePassword = async () => {
    try {
      const currentUser = await Auth.currentAuthenticatedUser();
      await Auth.changePassword(currentUser, currentPassword, newPassword);
      toast.info('Password changed');
    } catch (err) {
      console.warn(err);
      toast.error('Password not changed');
    } finally {
      setCurrentPassword('');
      setNewPassword('');
    }
  };

  return (
    <Modal
      button={(show) => (
        <Button onClick={show} className="mr-2 btn btn-white">
          <PasswordIcon className="inline w-5 h-5 mb-1 -ml-1 text-gray-500" />{' '}
          Change Password
        </Button>
      )}
      title="Change Password"
      content={() => (
        <>
          <Input
            label="Current Password"
            type="password"
            autoComplete="current-password"
            value={currentPassword}
            onChange={(e: ChangeEvent<HTMLInputElement>) =>
              setCurrentPassword(e.currentTarget.value)
            }
            onResetClick={(e: ChangeEvent<HTMLInputElement>) =>
              setCurrentPassword('')
            }
          />
          <Input
            label="New Password"
            type="password"
            autoComplete="new-password"
            value={newPassword}
            onChange={(e: ChangeEvent<HTMLInputElement>) =>
              setNewPassword(e.currentTarget.value)
            }
            onResetClick={(e: ChangeEvent<HTMLInputElement>) =>
              setNewPassword('')
            }
          />
        </>
      )}
      footer={(hide) => (
        <>
          <Button className="mr-2 btn btn-white" onClick={hide}>
            Cancel
          </Button>
          <Button
            className="btn"
            onClick={() => {
              changePassword();
              hide();
            }}
          >
            Change Password
          </Button>
        </>
      )}
    />
  );
};

export default ChangePasswordButton;
